module.exports = __webpack_public_path__ + "img/codeTwo.c36a6d5b.png";